import {isLoggedIn} from 'utils/auth'

export default (store, keycloak) => ({
  path: 'logout',
  onEnter: isLoggedIn(store),
  getComponent(nextState, callback) {
    require.ensure([], (require) => {
      const component = require('./Logout').default
      callback(null, component)
    }, 'Logout')
  },
  keycloak
})



// WEBPACK FOOTER //
// ./src/routes/Logout/index.js